import { useEffect, useState } from 'react'
import { useMyContext } from '../context/context'
import Token from '../utils/Token'

const useWebsocket = (modeFullScreen = false, isStarted = true) => {
  const { eventId, domainId } = useMyContext()
  const [data, setData] = useState(null)
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (isStarted) {
      let auth = false
      let ws = null

      ws = new WebSocket(
        `wss://dkoja9wmfb.execute-api.eu-west-3.amazonaws.com/prod?eventId=${eventId}&token=${
          modeFullScreen ? 'bww7jzu29fs5zfuhi80v' : Token.get()
        }&domainId=${domainId}`
      )

      ws.onopen = () => {
        auth = true
      }

      ws.onmessage = e => {
        setData(JSON.parse(e.data).data)
      }

      ws.onclose = () => {
        if (auth && count < 10)
          setTimeout(() => {
            setCount(prev => prev + 1)
          }, 1000)
      }

      return () => {
        auth = false
        if (ws) {
          ws.close()
        }
        ws = null
      }
    }
  }, [count, domainId, eventId, isStarted, modeFullScreen])

  return [data]
}

export default useWebsocket
